// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"0f4fd32d","323":"0f4fd32d","529":"0f4fd32d","816":"0f4fd32d"}[chunkId] + ".chunk.css";
};